// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Rational_Serialized from "../Data.Rational.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe);
var guard = /* #__PURE__ */ Control_Alternative.guard(Data_Maybe.alternativeMaybe);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var toRational = /* #__PURE__ */ Data_Rational_Serialized.toRational(Data_Rational_Serialized.toRationalInt);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Maybe.altMaybe);
var toStringR = function (r) {
    if (Data_Rational_Serialized.toDenominator(r) === 1) {
        return show(Data_Rational_Serialized.toNumerator(r));
    };
    if (Data_Boolean.otherwise) {
        return show(Data_Rational_Serialized.toNumerator(r)) + ("/" + show(Data_Rational_Serialized.toDenominator(r)));
    };
    throw new Error("Failed pattern match at Data.Rational.Extra (line 24, column 1 - line 24, column 32): " + [ r.constructor.name ]);
};
var toString = toStringR;
var toNumber = function (r) {
    return Data_Int.toNumber(Data_Rational_Serialized.toNumerator(r)) / Data_Int.toNumber(Data_Rational_Serialized.toDenominator(r));
};
var fromString = function (s) {
    var fromInt = function (s1) {
        return map(Data_Rational_Serialized.fromInt)(Data_Int.fromString(Data_String_Common.trim(s1)));
    };
    var fromFraction = function (s1) {
        var v = Data_String_Common.split("/")(s1);
        if (v.length === 2) {
            return bind(Data_Int.fromString(Data_String_Common.trim(v[1])))(function (denominator) {
                return discard(guard(denominator !== 0))(function () {
                    return apply(map(toRational)(Data_Int.fromString(Data_String_Common.trim(v[0]))))(pure(denominator));
                });
            });
        };
        return Data_Maybe.Nothing.value;
    };
    var fromDecimalFraction = function (s1) {
        var v = Data_String_Common.split(".")(Data_String_Common.trim(s1));
        if (v.length === 2) {
            return bind(Data_Int.fromString(v[0] + v[1]))(function (n) {
                return pure(toRational(n)(Data_Int.pow(10)(Data_String_CodePoints.length(v[1]))));
            });
        };
        return Data_Maybe.Nothing.value;
    };
    return alt(fromInt(s))(alt(fromFraction(s))(fromDecimalFraction(s)));
};
export {
    toString,
    fromString,
    toNumber
};
export {
    Rational,
    fromInt,
    toDenominator,
    toNumerator,
    toRational
} from "../Data.Rational.Serialized/index.js";
